import { Component, Input } from '@angular/core';
import { HidePopup } from '../../../personne.state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-popup-photo-error',
  templateUrl: './popup-photo-error.component.html',
  standalone: false
})
export class PopupPhotoErrorComponent {
  @Input()
  errorType: string;

  constructor(private readonly _store: Store) {}

  close() {
    this._store.dispatch(new HidePopup());
  }

  get errorMessageIdentifier() {
    const mapping = {
      internal: 'propriete.photo.erreur.texte-erreur-serveur',
      size: 'propriete.photo.erreur.texte-erreur-poids',
      moderated: 'propriete.photo.erreur.texte-erreur-moderation'
    };

    const defaultMessage = 'propriete.photo.erreur.texte-erreur-serveur';

    return mapping[this.errorType] ? mapping[this.errorType] : defaultMessage;
  }
}
